module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designFlag),
      expression: "designFlag"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(0), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请选择修复体材质",
      "size": "mini"
    },
    model: {
      value: (_vm.dataInfo.repairMaterial),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "repairMaterial", $$v)
      },
      expression: "dataInfo.repairMaterial"
    }
  }, [_c('el-option', {
    staticClass: "option-item",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "氧化锆",
      "value": "00"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "玻璃陶瓷",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "树脂",
      "value": "02"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designFlag),
      expression: "designFlag"
    }],
    staticClass: "input-form-wrap",
    staticStyle: {
      "padding": "10px 0px",
      "width": "280px",
      "margin-left": "6px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-radio",
    staticStyle: {
      "width": "130px"
    }
  }, [_c('div', {
    staticClass: "input-radio-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "aria-label": "否"
    },
    model: {
      value: (_vm.dataInfo.posHole),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "posHole", $$v)
      },
      expression: "dataInfo.posHole"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "aria-label": "是"
    },
    model: {
      value: (_vm.dataInfo.posHole),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "posHole", $$v)
      },
      expression: "dataInfo.posHole"
    }
  }, [_vm._v("是")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.dataInfo.posHole == '1' && !['1010120', '1010410'].includes(this.subCatalogId)) ? _c('input-number-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designFlag),
      expression: "designFlag"
    }],
    staticStyle: {
      "line-height": "40px",
      "margin-left": "4px"
    },
    attrs: {
      "label": "开孔直径",
      "required": "",
      "step": 0.1,
      "suffixText": 'mm'
    },
    model: {
      value: (_vm.dataInfo.holeDiameter),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "holeDiameter", $$v)
      },
      expression: "dataInfo.holeDiameter"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(2), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "filterable": "",
      "placeholder": "请选择植体系统",
      "size": "mini",
      "filter-method": _vm.filterSystem
    },
    on: {
      "change": function($event) {
        return _vm.getSystem(_vm.dataInfo.impSystem)
      }
    },
    model: {
      value: (_vm.dataInfo.impSystem),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "impSystem", $$v)
      },
      expression: "dataInfo.impSystem"
    }
  }, _vm._l((_vm.filterImpSystemList), function(item) {
    return _c('el-option', {
      key: item.implId,
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "label": item.implName,
        "value": item.implId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(3), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择植体型号",
      "size": "mini",
      "filterable": "",
      "filter-method": _vm.filterModel
    },
    on: {
      "change": _vm.getModel
    },
    model: {
      value: (_vm.tempModel),
      callback: function($$v) {
        _vm.tempModel = $$v
      },
      expression: "tempModel"
    }
  }, _vm._l((_vm.filterImpModelList), function(item) {
    return _c('el-option', {
      key: item.implId,
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "label": item.implName,
        "value": item.implId
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.dataInfo.impSystem === '其他') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(4), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.dataInfo.impExtra),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "impExtra", $$v)
      },
      expression: "dataInfo.impExtra"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isPlate == '1') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-plate"
  }, [_vm._m(5), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择导板类型",
      "size": "mini"
    },
    model: {
      value: (_vm.dataInfo.plateType),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "plateType", $$v)
      },
      expression: "dataInfo.plateType"
    }
  }, _vm._l((_vm.common.dict.get('biz_plate_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220' || _vm.subCatalogId == '1010310' || _vm.subCatalogId == '1010320' || _vm.subCatalogId == '1010410' || _vm.subCatalogId == '1010510' || _vm.subCatalogId == '1010120') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(6), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择扫描杆",
      "size": "mini"
    },
    model: {
      value: (_vm.dataInfo.scanningRod),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "scanningRod", $$v)
      },
      expression: "dataInfo.scanningRod"
    }
  }, [_c('el-option', {
    staticClass: "option-item",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "口内扫描杆",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "label": "口外扫描杆",
      "value": "02"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220' || _vm.subCatalogId == '1010310' || _vm.subCatalogId == '1010320' || _vm.subCatalogId == '1010410' || _vm.subCatalogId == '1010510' || _vm.subCatalogId == '1010120') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row"
  }, [_vm._m(7), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini",
      "placeholder": "请输入供应商信息",
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.dataInfo.scanningRodSupplier),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "scanningRodSupplier", $$v)
      },
      expression: "dataInfo.scanningRodSupplier"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010510') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-row",
    staticStyle: {
      "line-height": "60px"
    }
  }, [_vm._m(8), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini",
      "placeholder": "请输入杆卡类型信息"
    },
    model: {
      value: (_vm.dataInfo.collar),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "collar", $$v)
      },
      expression: "dataInfo.collar"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010510') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-precise",
    staticStyle: {
      "line-height": "60px"
    }
  }, [_vm._m(9), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini",
      "placeholder": "请输入精密附件供应商及型号信息"
    },
    model: {
      value: (_vm.dataInfo.subgingival),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "subgingival", $$v)
      },
      expression: "dataInfo.subgingival"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isBriCraft == '1' && _vm.subCatalogId != '1010510') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag || _vm.subCatalogId == '1010120'),
      expression: "!designFlag||subCatalogId=='1010120'"
    }],
    staticClass: "input-form-wrap-craft",
    staticStyle: {
      "line-height": "60px"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-radio-box",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "01"
    },
    model: {
      value: (_vm.dataInfo.briCraft),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "briCraft", $$v)
      },
      expression: "dataInfo.briCraft"
    }
  }, [_vm._v("氧化锆冠粘贴工艺")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "02"
    },
    model: {
      value: (_vm.dataInfo.briCraft),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "briCraft", $$v)
      },
      expression: "dataInfo.briCraft"
    }
  }, [_vm._v("树脂排牙工艺")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.catalogId == '10' && _vm.subCatalogId != '1010698' && _vm.subCatalogId != '1010699' && _vm.subCatalogId != '1010700') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.designFlag),
      expression: "!designFlag"
    }],
    class: _vm.subCatalogId == '1010510' || _vm.subCatalogId == '1010410' ? 'input-form-wrap addPadding' : 'input-form-wrap defaultPadding',
    staticStyle: {
      "width": "27%"
    },
    style: (_vm.subCatalogId == '1010410' ? 'margin-left: 278px;' : 'margin-left: 11px;')
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-radio"
  }, [_c('div', {
    staticClass: "input-radio-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.dataInfo.isEditScanModel),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "isEditScanModel", $$v)
      },
      expression: "dataInfo.isEditScanModel"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.dataInfo.isEditScanModel),
      callback: function($$v) {
        _vm.$set(_vm.dataInfo, "isEditScanModel", $$v)
      },
      expression: "dataInfo.isEditScanModel"
    }
  }, [_vm._v("编辑模型文件" + _vm._s(_vm.common.serv.get(_vm.subCatalogId).editScanModelBprice) + "元")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("修复体材质")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("冠部是否开孔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("植体系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("植体型号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("其他")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("导板类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("扫描杆")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("扫描杆供应商")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("杆卡类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("精密附件供应商及型号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("桥架上部修复工艺")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("口扫模型编辑")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d8e7e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/CompositeIndication/impSystem.vue
// module id = 621
// module chunks = 0